import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { TopBar, Button, Icon } from "@/components/ui";

export default function NotFoundPage(): ReactNode {
    const navigate = useNavigate();

    return (
        <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden max-w-[430px] mx-auto border-x border-white/5 shadow-2xl bg-background-dark">
            <div className="fixed inset-0 grid-pattern opacity-40 pointer-events-none" />

            <TopBar />

            <main className="relative z-10 flex-1 flex flex-col justify-center px-4 py-3 min-h-0 gap-2">
                <div className="relative flex flex-col items-center justify-center py-2">
                    <div
                        className="absolute inset-0 pointer-events-none"
                        style={{
                            background:
                                "radial-gradient(circle at 50% 50%, rgba(140, 37, 244, 0.15) 0%, transparent 70%)",
                        }}
                    />
                    <div className="relative">
                        <div className="size-16 rounded-full bg-accent-pink flex items-center justify-center shadow-[0_0_30px_rgba(244,37,140,0.4)] z-10 relative">
                            <Icon name="explore-off" size={36} />
                        </div>
                    </div>

                    <div className="text-center mt-3 space-y-1">
                        <h1 className="text-xl font-black uppercase italic leading-none tracking-tighter">
                            Page <span className="text-accent-pink">Not Found</span>
                        </h1>
                        <p className="text-white/60 font-inter font-medium text-xs">
                            The page you're looking for doesn't exist.
                        </p>
                    </div>
                </div>

                <div className="mt-auto space-y-2">
                    <Button
                        variant="secondary"
                        size="md"
                        fullWidth
                        onClick={() => navigate("/")}
                    >
                        Go Home
                    </Button>
                </div>
            </main>
        </div>
    );
}
